import { getCO2AequivalentSubscope6_Entfernung, getCO2AequivalentSubscope6_Uebernachtung, getCO2AequivalentSubscope69_Unterkunft } from '../getCO2Aequivalent';
import { getDataForKraftstoff } from './getDataForKraftstoff';
import { getStaticOption } from '../../../core/forms/helpers/getStaticOption';
import { IDs } from '../../../helpers/IDs';
import { getDatenqualitaet } from '../getDatenqualitaet';
import { KennzahlFaktor } from '../strukturiert/KennzahlFaktor';

export function processSubscope6(row: any, data: any, item: any, jahr: number, arr: any[]) {
    // console.log('SS6 ROW', row);
    if (row.parent_tid && row.parent_tid > 0) {
        return; // Das ist eine Entfernungs-Row, also raus
    }
    row = { ...row };

    // Konfig
    const co2_fussabdruck_ghg = (((data || {})[IDs.ENT_KONFIGURATION] || [])[0] || {}).co2_fussabdruck_modus === 'ghg';
    const modus = row.modus;

    let value = 0;
    let menge = 0;
    const subrows = arr.filter((sr: any) => sr.parent_tid === row.tid && sr.modus === modus);

    const arr_datenqualitaet: any[] = [];

    // console.log('SS6 - IN: ', jahr, row, subrows);
    if (row.firmenfahrzeug === 'Nein' && row.transportmittel) {
        let personen = 1;
        if (row.transportmittel === 'bus' || row.transportmittel === 'reisebus' ||
            row.transportmittel === 'bahn' || row.transportmittel === 'bahn_fern' ||
            row.transportmittel === 'tram' || row.transportmittel === 'flugzeug_international' ||
            row.transportmittel === 'flugzeug_national') {
            personen = +row.personen || 1;
        }
        const fakt_hin_rueck = (+row.hin_rueck === 2 || +row.hin_rueck_orig === 2) ? 1 : 2;
        if (!modus || modus === '0' || !co2_fussabdruck_ghg || modus === 'distance_based') {
            if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
                const names: any = {};
                subrows.forEach((sr: any) => {
                    let sr_personen = 1;
                    let hasFaktorPersonen = false;
                    if (sr.transportmittel === 'bus' || sr.transportmittel === 'reisebus' ||
                        sr.transportmittel === 'bahn' || sr.transportmittel === 'bahn_fern' ||
                        sr.transportmittel === 'tram' || sr.transportmittel === 'flugzeug_international' ||
                        sr.transportmittel === 'flugzeug_national') {
                        sr_personen = +row.personen || 1;
                        hasFaktorPersonen = true;
                    }
                    const faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, sr);
                    const entfernung = +sr.entfernung * fakt_hin_rueck * sr_personen;
                    const value_entf = entfernung * faktor_entf.wert;
                    menge += sr.entfernung;
                    value += value_entf;
                    let subname;
                    if (sr.transportmittel) {
                        subname = `${getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'transportmittel', sr.transportmittel)}${sr.kraftstoff ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'kraftstoff', sr.kraftstoff)})` : ''}`;
                        names[subname] = true;
                    }
                    if (!row.quelle) {
                        row.quelle = faktor_entf.quelle;
                    } else if (row.quelle.indexOf(faktor_entf.quelle) === -1) {
                        row.quelle += ';;' + faktor_entf.quelle;
                    }
                    if (!row.faktor_map) {
                        row.faktor_map = {};
                    }
                    row.faktor_map[faktor_entf.info] = {
                        info: subname,
                        menge: entfernung,
                        mengeOrig: +sr.entfernung,
                        menge_einheit: 'km',
                        menge_einheitOrig: 'km',
                        wert: faktor_entf.wert * 1000000,
                        einheit: 'gCO₂Äq/km',
                        quelle: faktor_entf.quelle,
                        formel_co2: hasFaktorPersonen ? 'co2_fahrt_personen' : 'co2_fahrt',
                        faktoren: [
                            {
                                value: fakt_hin_rueck,
                                type: KennzahlFaktor.TYPE_FAHRT,
                                formel: 'menge_fahrt'
                            },
                            ...(hasFaktorPersonen ? [
                                {
                                    value: sr_personen,
                                    type: KennzahlFaktor.TYPE_PERSONEN,
                                    formel: 'menge_fahrt_personen'
                                }
                            ] : [])
                        ]
                    };
                    arr_datenqualitaet.push({
                        wert: value_entf === 0 ? 0.1 : value_entf, // hier Emission t CO2 Äq.
                        emissionsfaktor: +faktor_entf.datenqualitaet_distanz,
                        bewertung: +row.bewertung_emissionsfaktor,
                        datenherkunft: +row.datenherkunft
                    });
                });
                row.faktor_einheit = 'gemischt';
                row.name = Object.keys(names).join('\n');
            } else {
                const faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, row);
                // console.log('Faktor Entf: ', faktor_entf, row);
                const value_entf = +row.entfernung * faktor_entf.wert * fakt_hin_rueck * personen;
                value += value_entf;
                menge = row.entfernung;
                row.faktor = faktor_entf.wert * 1000000;
                row.faktor_einheit = 'gCO₂Äq/km';
                row.quelle = faktor_entf.quelle;
                row.name = `${getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'transportmittel', row.transportmittel)}${row.kraftstoff ? ` (${getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'kraftstoff', row.kraftstoff)})` : ''}`;
                if (!row.faktor_map) {
                    row.faktor_map = {};
                }
                row.faktor_map[faktor_entf.info] = {
                    info: row.name,
                    menge: +row.entfernung,
                    wert: faktor_entf.wert * 1000000,
                    einheit: 'gCO₂Äq/km',
                    quelle: faktor_entf.quelle,
                    wert_um: fakt_hin_rueck,
                    quelle_um: 'Faktor Hin- und Rückfahrt',
                    wert_um_co2: fakt_hin_rueck * personen,
                    quelle_um_co2: 'Faktor Hin- und Rückfahrt × Personen'
                };
                if(faktor_entf && (faktor_entf.datenqualitaet_distanz || faktor_entf.datenqualitaet_distanz === 0) && (faktor_entf.bewertung_emissionsfaktor || faktor_entf.bewertung_emissionsfaktor === 0)) {
                    arr_datenqualitaet.push({
                        wert: value_entf === 0 ? 0.1 : value_entf, // hier Emission t CO2 Äq.
                        emissionsfaktor: +faktor_entf.datenqualitaet_distanz,
                        bewertung: +row.bewertung_emissionsfaktor,
                        datenherkunft: +row.datenherkunft
                    });
                }
            }
            row.menge = menge * fakt_hin_rueck * personen;
            // row.menge = menge;
            row.einheit = 'km'; // +  '(' + fakt_hin_rueck + ')';
        } else if (modus === 'spend_based') {
            if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
                const names: any = {};
                subrows.forEach((sr: any) => {
                    const faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, sr);
                    const value_spend = +sr.kosten * faktor_entf.wert_euro;
                    if (row.value) {
                        row.value += value_spend; // * +row.menge;
                        row.kosten += +sr.kosten;
                    } else {
                        row.value = value_spend; // * +row.menge;
                        row.kosten = +sr.kosten;
                    }
                    value += value_spend;
                    if (sr.transportmittel) {
                        names[getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'transportmittel', sr.transportmittel)] = true;
                    }
                    // console.log('SS6 subrow: ', jahr, faktor_entf, sr.kosten, row.value, row);
                    if (!row.quelle) {
                        row.quelle = faktor_entf.quelle;
                    } else if (row.quelle.indexOf(faktor_entf.quelle) === -1) {
                        row.quelle += ';;' + faktor_entf.quelle;
                    }
                    arr_datenqualitaet.push({
                        wert: value_spend, // hier Emission t CO2 Äq.
                        emissionsfaktor: +faktor_entf.datenqualitaet_kosten,
                        bewertung: +row.bewertung_emissionsfaktor,
                        datenherkunft: +row.datenherkunft
                    });
                });
                row.menge = row.kosten;
                row.faktor = (row.value / row.kosten) * 1000000;
                row.name = Object.keys(names).join('\n');
            } else {
                const faktor_entf = getCO2AequivalentSubscope6_Entfernung(data, jahr, row);
                const value_euro = (+row.kosten || 0) * (faktor_entf.wert_euro || 0);
                value = value_euro;
                row.menge = row.kosten;
                row.faktor = faktor_entf.wert_euro * 1000000;
                row.quelle = faktor_entf.quelle;
                row.name = getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'transportmittel', row.transportmittel);
                arr_datenqualitaet.push({
                    wert: value_euro, // hier Emission t CO2 Äq.
                    emissionsfaktor: +faktor_entf.datenqualitaet_kosten,
                    bewertung: +row.bewertung_emissionsfaktor,
                    datenherkunft: +row.datenherkunft
                });
            }
            row.einheit = '€';
            row.faktor_einheit = 'gCO₂Äq/€';
        } else if (modus === 'fuel_based') {
            if (subrows.length > 0 && +row.teilstrecken_orig === 1) {
                const names: any = {};
                subrows.forEach((sr: any) => {
                    const fuel_item = getDataForKraftstoff(sr, jahr, data);
                    if (row.verbrauch) {
                        row.verbrauch += sr.verbrauch;
                        row.value += fuel_item.co2;
                    } else {
                        row.verbrauch = sr.verbrauch;
                        row.value = fuel_item.co2;
                    }
                    names[sr.energietraeger_tid] = true;
                    if (!row.quelle) {
                        row.quelle = fuel_item.quelle;
                    } else if (row.quelle.indexOf(fuel_item.quelle) === -1) {
                        row.quelle += ';;' + fuel_item.quelle;
                    }
                    if (!row.faktor_map) {
                        row.faktor_map = {};
                    }
                    row.faktor_map[fuel_item.energietraeger] = {
                        info: sr.energietraeger_tid,
                        menge: +sr.verbrauch,
                        menge_einheit: 'kWh',
                        menge_einheitOrig: fuel_item.einheit,
                        wert: fuel_item.faktor_co2 * 1000000,
                        quelle: fuel_item.quelle_co2,
                        einheit: 'gCO₂Äq/kWh',
                        wert_um: fuel_item.faktor_um,
                        einheit_um: `kWh/${fuel_item.einheit}`,
                        quelle_um: fuel_item.quelle_um,
                        wert_um_co2: fuel_item.faktor_um,
                        einheit_um_co2: `kWh/${fuel_item.einheit}`,
                        quelle_um_co2: fuel_item.quelle_um,
                    };
                    arr_datenqualitaet.push({
                        wert: fuel_item.co2, // hier Emission t CO2 Äq.
                        emissionsfaktor: +fuel_item.datenqualitaet_1, // Warum hier Scope 1 und nicht 3?
                        datenherkunft: +row.datenherkunft,
                        bewertung: +row.bewertung_emissionsfaktor
                    });
                    menge += sr.verbrauch * fuel_item.faktor_um;
                    value += sr.verbrauch * fuel_item.faktor_um * fuel_item.faktor_co2;
                });
                row.name = Object.keys(names).join('\n');
                row.faktor_einheit = 'gCO₂Äq/kWh';
                row.menge = menge;
                row.value = value;
                row.einheit = 'kWh';
            } else {
                const fuel_item = getDataForKraftstoff(row, jahr, data);
                row.name = row.energietraeger_tid;
                value = fuel_item.co2;
                row.menge = row.verbrauch * fuel_item.faktor_um;
                row.einheit = 'kWh';
                row.mengeOrig = row.verbrauch;
                row.einheitOrig = fuel_item.einheit;
                row.faktor = fuel_item.faktor_co2 * 1000000;
                row.faktor_einheit = 'gCO₂Äq/kWh';
                row.quelle = fuel_item.quelle_co2;
                row.formel_co2 = 'umrechnung_co2';
                row.faktoren = [
                    {
                        info: `Umrechnung ${fuel_item.einheit}`,
                        value: fuel_item.faktor_um,
                        type: KennzahlFaktor.TYPE_UMRECHNUNG,
                        quelle: fuel_item.quelle_um,
                        einheit: `kWh/${fuel_item.einheit}`,
                        formel: 'verbrauch_umrechnung'
                    }
                ];
                arr_datenqualitaet.push({
                    // wert: +row.menge,
                    wert: fuel_item.co2,
                    emissionsfaktor: +fuel_item.datenqualitaet_1,
                    datenherkunft: +row.datenherkunft,
                    bewertung: +row.bewertung_emissionsfaktor
                });
            }
        } else if (modus === 'user_specific') {
            row.name = row.name_nutzer;
            row.menge = row.menge_nutzer;
            row.einheit = row.einheit_nutzer;
            value = row.menge_nutzer && row.faktor_nutzer ? row.faktor_nutzer * row.menge_nutzer : row.menge_nutzer;
            row.faktor = row.faktor_nutzer ? row.faktor_nutzer * 1000000 : null;
            row.faktor_einheit = `gCO₂Äq/${row.einheit_nutzer || ''}`;
            row.quelle = `Eingabe durch Nutzer:in${row.quelle_nutzer ? ` / Quelle: ${row.quelle_nutzer}` : ''}`;
            arr_datenqualitaet.push({
                wert: value,
                emissionsfaktor: +row.datenqualitaet_emissionsfaktor,
                datenherkunft: +row.datenherkunft,
                bewertung: +row.bewertung_emissionsfaktor
            });
        }
    } else {
        row.name = 'Firmenfzg.';
        row.einheit = 'Firmenfzg.';
    }

    if (
        row.uebernachtungen === 'Ja' && row.reiseland && row.uebernachtungen_anzahl > 0
        // WKETOOL-212: Bugfix Übernachtungsemission fehlt bei Nutzerspezifisch (user_specific)
        && (row.firmenfahrzeug === 'Ja' || modus !== 'user_specific')
    ) {
        const personen_ueb = row.teilnehmer || 1;
        let faktor_ueb = getCO2AequivalentSubscope6_Uebernachtung(data, jahr, row.reiseland);
        let value_ueb = +row.uebernachtungen_anzahl * +faktor_ueb.wert * personen_ueb;
        if (row.reiseland === 'deutschland') {
            const faktor_unt = getCO2AequivalentSubscope69_Unterkunft(data, jahr, row.unterkunft);
            if (faktor_unt) {
                value_ueb = +row.uebernachtungen_anzahl * +faktor_unt.wert * personen_ueb;
                faktor_ueb = faktor_unt;
            }
        }
        value += value_ueb;
        row.name += faktor_ueb.name ? `(${faktor_ueb.name})` : '';

        if (!row.faktor_map) {
            row.faktor_map = {};
            if (row.faktor && row.menge) {
                row.faktor_map[row.tid] = {
                    info: row.name,
                    menge: row.menge,
                    menge_einheit: row.einheit,
                    wert: row.faktor,
                    einheit: row.faktor_einheit,
                    quelle: row.quelle
                };
            }
        }
        row.faktor = null;
        row.faktor_einheit = 'gemischt';
        const fktUeN = {
            info: 'Übernachtungen',
            menge: +row.uebernachtungen_anzahl * personen_ueb,
            menge_einheit: 'ÜN',
            wert: +faktor_ueb.wert * 1000000,
            einheit: 'gCO₂Äq/ÜN',
            quelle: faktor_ueb.quelle
        };
        if (row.name === 'Firmenfzg.') {
            // ÜN wird in setKennzahlS3 ausgefiltert!
            // Hier nutzen wir einen anderen Key.
            row.faktor_map['ÜN_co2'] = fktUeN;
        } else {
            row.faktor_map['ÜN'] = fktUeN;
        }

        const unterkunft = getStaticOption(IDs.ENT_CO2_SCOPE3_REISEN, 'unterkunft', row.unterkunft);
        if (row.transportmittel === 'uebernachtung') {
            row.name += `\n${unterkunft}`;
        } else {
            row.name += `\nÜbernachtung: ${unterkunft}`;
        }

        if (!row.quelle) {
            row.quelle = faktor_ueb.quelle;
        } else if (row.quelle.indexOf(faktor_ueb.quelle) === -1) {
            row.quelle += ';;' + faktor_ueb.quelle;
        }
        arr_datenqualitaet.push({
            wert: value_ueb,
            emissionsfaktor: +faktor_ueb.datenqualitaet,
            datenherkunft: +row.datenherkunft,
            bewertung: +row.bewertung_emissionsfaktor
        });
    }
    const key_wert = 'co2_fussabdruck_s3_ss6_wert';
    const key_items = 'co2_fussabdruck_s3_ss6_items';
    if (!item[key_items]) {
        item[key_items] = [];
    }
    row.value = value;

    // Datenqualität setzen
    row.datenqualitaet = getDatenqualitaet(arr_datenqualitaet);

    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + (row.value || 0);
    item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + (row.value || 0);
    item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + (row.value || 0);
}
